var pathPrefix = '';
var fileAliases = {};
export function setPathPrefix(prefix) {
  pathPrefix = prefix;
}
export function getPathPrefix() {
  return pathPrefix;
}
export function addAliases(aliases) {
  Object.assign(fileAliases, aliases);
}
export function resolvePath(filename) {
  for (var alias in fileAliases) {
    if (filename.startsWith(alias)) {
      var replacement = fileAliases[alias];
      return filename.replace(alias, replacement);
    }
  }

  filename += pathPrefix;
  return filename;
}